import { gql } from '@apollo/client'

export const DELETE_PROCESSING_MUTATION = gql`
  mutation deleteProcessing($id: ID!) {
    deleteProcessing(id: $id)
  }
`
